import { render, staticRenderFns } from "./companyStandard.vue?vue&type=template&id=1c8759af&scoped=true"
import script from "./companyStandard.vue?vue&type=script&lang=js"
export * from "./companyStandard.vue?vue&type=script&lang=js"
import style0 from "./companyStandard.vue?vue&type=style&index=0&id=1c8759af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8759af",
  null
  
)

export default component.exports